import { useState, useEffect } from 'react';
import { modalBus } from './modalBus';

export function useModalChannel(modalId) {
    const [open, setOpen] = useState(false);
    const [payload, setPayload] = useState(null);

    useEffect(() => {
        const openKey = `open:${modalId}`;
        const closeKey = `close:${modalId}`;
        const handleOpen = (data) => {
            setPayload(data !== undefined ? data : null);
            setOpen(true);
        };
        const handleClose = () => {
            setOpen(false);
            setPayload(null);
        };
        modalBus.on(openKey, handleOpen);
        modalBus.on(closeKey, handleClose);
        return () => {
            modalBus.off(openKey, handleOpen);
            modalBus.off(closeKey, handleClose);
        };
    }, [modalId]);

    const close = () => {
        modalBus.emit(`close:${modalId}`);
    };

    return { open, payload, close };
}
